export type CareerPlanLatestTab = "goals" | "results" | "answers";

export function careerPlanLatestTabFromSearch(searchParams: URLSearchParams): CareerPlanLatestTab {
  const tab = searchParams.get("tab");
  if (tab === "results" || tab === "answers") return tab;
  return "goals";
}

export function careerPlanCompetencyIdFromSearch(searchParams: URLSearchParams): string | null {
  const competencyId = searchParams.get("competencyId")?.trim() ?? "";
  return competencyId || null;
}

export function careerProfileGoalsHref(pgaId: string): string {
  return `/people/${pgaId}/career/career-profile/goals`;
}

export function careerProfileExperienceIndexHref(pgaId: string): string {
  return `/people/${pgaId}/career/career-profile/experience-index`;
}

export function careerProfileExperienceIndexAssessmentHref(pgaId: string, competencyId: string): string {
  const params = new URLSearchParams({ competencyId });
  return `/people/${pgaId}/career/career-profile/experience-index/assessment?${params.toString()}`;
}

export function careerProfilePathFromLatest(pgaId: string, search: string | URLSearchParams): string {
  const searchParams =
    typeof search === "string" ? new URLSearchParams(search.startsWith("?") ? search.slice(1) : search) : search;
  const tab = careerPlanLatestTabFromSearch(searchParams);
  if (tab === "answers") {
    const competencyId = careerPlanCompetencyIdFromSearch(searchParams);
    if (competencyId) {
      return careerProfileExperienceIndexAssessmentHref(pgaId, competencyId);
    }
    return careerProfileExperienceIndexHref(pgaId);
  }
  if (tab === "results") {
    return careerProfileExperienceIndexHref(pgaId);
  }
  return careerProfileGoalsHref(pgaId);
}
